/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Draft_WaitingInputs */

const en_us2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new plan is waiting`)
};

const pt_br2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um novo plano está esperando`)
};

const es_419_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay un nuevo plan esperando`)
};

const pt_pt2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um novo plano à espera`)
};

const fr_fr2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nouveau programme t'attend`)
};

const de_de2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein neuer Plan wartet`)
};

const it_it2_today_draft_waiting = /** @type {(inputs: Today_Draft_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una nuova scheda ti aspetta`)
};

/**
* | output |
* | --- |
* | "A new plan is waiting" |
*
* @param {Today_Draft_WaitingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_draft_waiting = /** @type {((inputs?: Today_Draft_WaitingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Draft_WaitingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_draft_waiting(inputs)
	if (locale === "es-419") return es_419_today_draft_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_today_draft_waiting(inputs)
	if (locale === "fr-FR") return fr_fr2_today_draft_waiting(inputs)
	if (locale === "de-DE") return de_de2_today_draft_waiting(inputs)
	if (locale === "it-IT") return it_it2_today_draft_waiting(inputs)
	return en_us2_today_draft_waiting(inputs)
});
export { today_draft_waiting as "today.draft_waiting" }